'use strict';

angular.module('atex.dam').directive('damArticleResources', ['$state', function ($state) {
  return {
    restrict: 'E',
    templateUrl: 'views/dam-article-resources.html',
    replace: true,

    scope: {
      entry: "="
    },

    link: function (scope) {
      function empty(resources) {
        return (!(resources && resources.length>0));
      }

      scope.resources = atex.onecms.ObjectUtils.getByPath(scope.entry, '_data/aspects/contentData/data/resources');
      if (empty(scope.resources)) {
        scope.resources = atex.onecms.ObjectUtils.getByPath(scope.entry, '_data/aspects/contentData/data/images');
      }

      scope.open = function () {
        $state.go('list.relations', { 'id' : scope.entry.id });
      };
    }
  };
}]);
